import TokenManager from './tokenmanager';

export default class HttpClient {
    static send = async (uri, verb, body) => {
        var accessToken = await TokenManager(this.getScopeResourcePath(uri.toString()));

        var requestObj = {
            method: verb === undefined ? 'GET' : verb,
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'OperationTrackingId': "portal-" + Date.now(),
                'UrnTrackingValue': localStorage.getItem("_urn"),
                'Authorization': 'Bearer ' + accessToken,
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_HALLEY_API_SUSCRIPTION_KEY
            }
        }

        if (body != null) {
            requestObj.body = JSON.stringify(body);
        }

        try {
            return await fetch(uri, requestObj);
        } catch (exception) {
            return this.handleError(exception);
        }
    }

    static getCors = async (uri) => {
        var requestObj = {
            method: 'GET',
            cache: 'no-cache',
            mode: 'cors',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "origin": "*"
            },
            referrerPolicy: 'no-referrer'
        }

        try {
            return await fetch(uri, requestObj);
        } catch (exception) {
            return this.handleError(exception);
        }
    }

    static getCached = async (uri) => {
        var requestObj = {
            method: 'GET',
            cache: 'force-cache',
            credentials: 'same-origin',
            mode: 'cors',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "origin": "*",
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_HALLEY_API_SUSCRIPTION_KEY
            },
            referrerPolicy: 'no-referrer'
        }

        try {
            return await fetch(uri, requestObj);
        } catch (exception) {
            return this.handleError(exception);
        }
    }

    static handleError = (exception) => {
        return {
            ok: false,
            async json() {
                return {
                    errorMessage: `Fetch error ${exception.message}. Please contact support.`,
                    errorCode: "COMM.FAILURE.001",
                    errorTranslateCode: "alert.warning.message",
                }
            }
        };
    }

    static getScopeResourcePath = (resourcePath) => {
        const resources = [
            {
                endpoint: process.env.REACT_APP_AUTHORIZATION_API_URL,
                scope: process.env.REACT_APP_BACKEND_API_SCOPE
            }];
        return resources.find(x => resourcePath.startsWith(x.endpoint, 0))?.scope;
    }
}
